<template>
	<div>
		<!--        <raw-displayer :value="json"></raw-displayer>-->
		<base-renderer
			@end="
				() => {
					$emit('end')
				}
			"
			@end2="
				val => {
					$emit('end2', val)
				}
			"
			:chiave="uuid()"
			:dati="json"
			:toggleBorders="toggleBorders"
			:logged="logged"
			v-if="load"
			style="padding-bottom: 150px"
		></base-renderer>
	</div>
</template>
<script>
import Renderer from "@/modules/builder/components/Renderer"
import RawDisplayer from "@/modules/builder/components/raw-displayer"
import BaseRenderer from "@/modules/flowcharts/base-renderer"
import { uuid } from "@/modules/builder/utils/utils"
import { mapMutations } from "vuex"
/*
 * spiegazione breve di cosa fa flat renderer
 *
 * in ingresso prende i nodi non ordinati, così come vengono trattati da drawflow o da chi per esso.
 *
 * da questi prende il primo, identificabile, e scende l'albero innestando i nodi successivi come rami del primo nodo.
 * in caso di diramazioni che portano più volte allo stesso nodo, questo viene duplicato insieme a tutta la sua discendenza tutte le volte necessarie in tutte le casistiche possibili.
 * questo crea, in caso di alberature complesse, molto rapidamente una struttura non facilemtne navigabile a mano, ma è la maniera più rapida.
 * Una volta creata l'alberatura viene passata insieme a qualche altra variabile a base-renderer
 *
 * l'effettivo funzionamento di questo file nel dettaglio è a me sconosciuto, non me ne sono occupato in prima persona
 *
 *
 *
 *
 * */
export default {
	name: "flat-renderer.vue",
	components: { BaseRenderer, RawDisplayer, Renderer },
	props: ["dati", "toggleBorders", "logged"],
	data() {
		return {
			nodes: [],
			jsonDisplay: [],
			json: { start: {} },
			tmp: [],
			load: false
		}
	},
	async mounted() {
		this.nodes = JSON.parse(JSON.stringify(this.dati))
		this.json.start = {
			// oggetto di appoggio
			id: this.nodes[0].id,
			children: this.nodes[0].children,
			value: this.nodes[0].value,
			wiki: this.nodes[0].wiki
		}

		if (this.nodes[0].children.length !== 0) {
			// creazione array figli se non esiste
			this.tmp = []
			for (let i = 0; i < this.nodes[0].children.length; i++) {
				const child = this.nodes.filter(x => {
					return String(x.id) === this.nodes[0].children[i]
				}) // prendo dal ref il nodo intero
				this.tmp.push(child[0])
				this.json.start.children = [] // switcho children e chi
				this.json.start.children = this.tmp
				delete this.json.start["chi"] // elimino chi d'appoggio
				this.getChildren(this.json.start.children[0]) // brrr
			}
		}
		const tmp = this.json.start // variabile d'appoggio per eliminare .start
		delete this.json["start"] // elimino start
		this.json = tmp // rimetto tutto in un unico oggetto
		this.display() // generazione dei nodi da visualizzare

		this.load = true
	},
	methods: {
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING",
			start: "compilation/START"
		}),
		uuid,
		getChildren(obj) {
			if (obj) {
				if (obj.children.length !== 0) {
					// se non ha figli non fare niente
					for (let i = 0; i < obj.children.length; i++) {
						if (typeof obj.children[i] !== "object") {
							//  se non è già stato esplorato questo nodo <- è un oggetto e non un int
							const child = this.nodes.filter(x => String(x.id) === String(obj.children[i]))[0] // prendo dal ref il nodo intero
							obj.children[i] = child
							this.getChildren(child) // richiama la funzione passando il nodo figlio corrente
						}
					}
				}
			}
		},
		//non DOVREBBE più essere utilizzato

		display() {
			if (this.json.value && this.json.children) {
				this.jsonDisplay.push({
					id: this.json.id,
					component: this.json.value[0],
					display: true,
					children: this.json.children.map(x => (x ? x.id : undefined))
				}) // primo elemento root
			}

			for (let i = 0; i < this.json.children.length; i++) {
				this.getInfo(this.json.children[i], this.json.id, Math.floor(Math.random() * 1000)) // brrr
			}
		},
		//non DOVREBBE più essere utilizzato

		getInfo(obj, oldid, rand_id = undefined) {
			if (obj) {
				if (obj.question.value !== "") {
					// è una domanda -> push di un nuovo oggetto con id random + domande e risposta
					// var isQuestionVisible = false
					// var parent= obj.parent.filter(x => x==oldid)
					// parent.forEach(parEl => {
					//     let element = this.jsonDisplay.filter(x => x.id == parEl)
					//
					//     if(element[0].display===true){
					//         isQuestionVisible=true
					//     }
					//
					//     element[0].children.push(rand_id)
					//
					//
					// })

					this.jsonDisplay.push({
						id: rand_id,
						question: obj.question.value,
						answers: obj.question.map,
						children: obj.children.map(x => (x ? x.id : undefined)),
						parent: obj.parent.filter(x => x == oldid),
						wiki: obj.wiki
					})
				}

				this.jsonDisplay.push({
					id: obj.id,
					wiki: obj.wiki,
					component: obj.value ? obj.value[0] : null,
					display: false,
					children: obj.children.map(x => (x ? x.id : undefined)),
					parent: obj.parent.filter(x => x == oldid)
				}) // pusha le info di base (id, componente da renderizzare e display)
				if (obj.children.length !== 0) {
					// attraversa i figli se ne ha
					for (let i = 0; i < obj.children.length; i++) {
						this.getInfo(obj.children[i], obj.id, Math.floor(Math.random() * 1000)) // brrr
					}
				}
			}
		},
		//non DOVREBBE più essere utilizzato
		answer(obj, answer) {
			// nasconde tutte le risposte (serve se si switcha tra le risposte)
			for (let i = 0; i < obj.answers.length; i++) {
				const element = this.jsonDisplay.find(x => x.id === obj.answers[i].ref)
				element["display"] = false
				this.recursiveDisplaySetter(element, false)
			}
			/*
			 {
			 id: ...,
			 question: testo della domanda,
			 answers: [
			 {ref: int, value: testo risposta},
			 {ref: int, value: testo risposta}
			 ]
			 }
			 */
			const answerRef = obj.answers.find(x => x.value === answer).ref // trova il ref (int) della risposta da trovare cui il value sia uguale alla risposta inserita
			const element = this.jsonDisplay.find(x => x.id === answerRef) // prendo nodo con lo stesso ref e lo visualizzo
			element["display"] = true
			this.recursiveDisplaySetter(element, true)
		}
	}
}
</script>
